import { ALERT_CONFIG } from '../configs/alertConfig';
import { CAMPAIGN_CONFIGS } from '../configs/campaignConfigs';
import { deductibleConfig } from '../configs/deductibleConfig';
import { PRODUCTS } from '../lib/constants/appConstants';
import { AlertConfig } from '../interfaces/Types';
import { Validator } from '../utils/Validator';
import { InsuranceHelper } from './InsuranceHelper';

export class ConfigHelper {
  static isFeatureEnabled = (feaureTag: string) => {
    let isEnabled = false;
    const dataLayer = (window as any).dataLayer || {};
    if (!InsuranceHelper.isEmptyObject(dataLayer)) {
      const featureEntry =
        dataLayer.find((data: any) => data.event === feaureTag) || {};
      isEnabled = !InsuranceHelper.isEmptyObject(featureEntry);
    }
    return isEnabled;
  };

  static getCampaignDiscountPercentages = (product: string, channel: string) => {
    if (!product || !channel) {
      return [];
    }
    const campaignList = CAMPAIGN_CONFIGS.find((campaignList) => {
      return campaignList.product === product && campaignList.channel === channel;
    });
    return campaignList?.campaigns.map((campaign) => campaign.campaignDiscountPercentage) || [];
  };

  static getCampaignDetails = (product: string, channel?: string) => {
    if (!product || !channel) {
      return [];
    }
    const campaignList = CAMPAIGN_CONFIGS.find((campaignList) => {
      return campaignList.product === product && campaignList.channel === channel;
    });
    return campaignList?.campaigns.map((campaign) => ({
        title: campaign.campaignName,
        description: campaign.campaignDescription,
        value: `${campaign.campaignDiscountPercentage} %`
      })) || [];
  }

  static getDeductibleInfo = (product: string, packageCode: string) => {
    const productDeductibles = deductibleConfig.find(
      (config: any) => config.product === product
    );
    let deductibleInfo;
    if (
      productDeductibles &&
      !InsuranceHelper.isEmptyObject(productDeductibles)
    ) {
      deductibleInfo = productDeductibles?.dedutibleInfo.find(
        (deductible: any) => {
          return deductible?.packageCode === packageCode;
        }
      );
    }
    return deductibleInfo;
  };
  static isBackButtonEnabledForOfferPage = (product: string) =>
    product === PRODUCTS.HOME || product === PRODUCTS.VILLA || product === PRODUCTS.MC;

  static getAlertMessage = (product: string, page: string, channel: string) => {
    let alertInfo = {
      title: '',
      message: ''
    };
    const currentDate = new Date().toLocaleDateString('sv');
    if (product && page && channel) {
      ALERT_CONFIG.forEach((alert: AlertConfig) => {
        if (
          alert.product === product &&
          alert.channel === channel &&
          alert.page === page &&
          Validator.isDateInRange(currentDate, alert.startDate, alert.endDate)
        ) {
          alertInfo = {
            title: alert.alertTitle || '',
            message: alert.alertMessage || ''
          };
        }
      });
    }
    return alertInfo;
  };
}
